<template>
  <div class="frame-page h-full !m-0px p-20px flex flex-column">
    <vxe-toolbar class-name="px-8px">
      <template #buttons>
        <vxe-button @click="showForm()" content="新增" status="primary" icon="fa fa-plus"/>
        <div class="h-input-group ml-8px">
          <span class="h-input-addon">日期：</span>
          <DateRangePicker v-model="dateRange"/>
        </div>
        <div class="h-input-group ml-8px">
          <span class="h-input-addon">转出账户：</span>
          <Select class="w-120px" :datas="accountList" keyName="id" titleName="name" v-model="query.outAccountId">
            <template #show="{value}">{{ value.code }} - {{ value.name }}</template>
            <template #item="{item}">{{ item.code }} - {{ item.name }}</template>
          </Select>
        </div>
        <div class="h-input-group ml-8px">
          <span class="h-input-addon">转入账户：</span>
          <Select class="w-120px" :datas="accountList" keyName="id" titleName="name" v-model="query.inAccountId">
            <template #show="{value}">{{ value.code }} - {{ value.name }}</template>
            <template #item="{item}">{{ item.code }} - {{ item.name }}</template>
          </Select>
        </div>
        <vxe-button :loading="loading" @click="doSearch" class="ml-8px" content="查询" icon="fa fa-search" status="primary"/>
      </template>
      <template #tools>
        <vxe-button @click="loadList();loadAccount();" content="刷新" icon="fa fa-television"/>
        <vxe-button @click="printList()" content="打印" icon="fa fa-print"/>
        <!--        <vxe-button content="导出" icon="fa fa-download"/>-->
        <!--        <vxe-button content="导入" icon="fa fa-upload"/>-->
        <!-- <vxe-button @click="batchDelete" content="批量删除" icon="fa fa-trash"/> -->
        <!--        <vxe-button content="生成凭证" status="primary"/>-->
      </template>
    </vxe-toolbar>
    <div class="flex-1">
      <vxe-table ref="xTable" :loading="loading" :data="results.results" height="auto">
        <vxe-column field="transferDate" width="140" title="日期"/>
        <vxe-column field="digest" title="摘要"/>
        <vxe-column field="outAccount" width="200" title="转出账户"/>
        <vxe-column field="inAccount" width="200" title="转入账户"/>
        <vxe-column field="amount" width="120" align="right" title="金额" formatter="toMoney"/>
        <vxe-column field="remark" title="备注"/>
        <!-- <vxe-column field="voucherTitle" title="关联凭证" width="100" align="center"/> -->
        <!-- jxdz -->
        <vxe-column title="关联凭证" field="voucherTitle" width="100" align="center">
          <template #default="{row}">
            <router-link class="text-hover primary-color" width="1100px"
                          v-if="row.voucherId"
                          :to="{name:'VoucherForm',params:{voucherId:row.voucherId}}">
              {{ row.voucherTitle }}
            </router-link>
          </template>
        </vxe-column>
        <vxe-column field="id" title="操作" width="200" align="center">
          <template #default="{row}">
            <div class="actions" v-show="!row.voucherId">
              <span @click="showForm(row)">编辑</span>
              <span @click="remove(row)">删除</span>
              <!-- jxd -->
              <span @click="goPz(row)">生成凭证</span>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <vxe-pager @page-change="onPageChange"
               v-model:current-page="page.page"
               v-model:page-size="page.pageSize"
               :total="results.total"
               :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
      <template #left>
        <vxe-button @click="loadList()" type="text" size="mini" icon="fa fa-refresh" :loading="loading"></vxe-button>
      </template>
    </vxe-pager>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "InternalTransfer"
}
</script>

<script setup>
import {layer} from "@layui/layer-vue";
import {h, ref} from "vue";
import InternalTransferForm from "@/views/cashier/transfer/InternalTransferForm";
import CashierTransfer from "@/api/CashierTransfer";
import CashierAccount from "@/api/CashierAccount";
import manba from "manba";
import {confirm, message} from "heyui.ext";
import {useStore} from "vuex";
import Qs from "qs";
import VoucherForm from "@/views/voucher/VoucherForm.vue";
import setting from "../../api/setting";
// 在setup中定义事件处理器
import { onMounted, onUnmounted } from 'vue'

const handlePopstate = (event) => {
  // 获取完整hash值（如 #/cashier/transfer）
  const currentHash = window.location.hash
  // 判断是否切换回当前页面（根据实际路由配置调整）
  if (currentHash === '#InternalTransfer') { // 替换为实际路由hash
    loadAccount()
  }
}

// 组件挂载时绑定
onMounted(() => {
  window.addEventListener('popstate', handlePopstate)
})

// 组件销毁时解绑
onUnmounted(() => {
  console.log("销毁")
  window.removeEventListener('popstate', handlePopstate)
})

const store = useStore();
const currentAccountDate = manba(store.state.currentAccountSets.currentAccountDate);
const startDate = ref(currentAccountDate.startOf(manba.MONTH).format());
const endDate = ref(currentAccountDate.endOf(manba.MONTH).format());

const loading = ref(false);
const xTable = ref(null);
const accountList = ref([]);

const tablePrint = {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column, 
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
        `
      }

const results = ref({
  results: [],
  total: 0,
});

const page = ref({
  page: 1,
  pageSize: 20
})

const query = ref({
  outAccountId: null,
  inAccountId: null
})
const dateRange = ref({
  start: startDate.value,
  end: endDate.value
})

//jxdz
const goPz = (row) => {
  let inAcc;
  let outAcc;
  let details = [];
  let flg = true;
  accountList.value.forEach(item =>{
    if(item.id === row.inAccountId){
      if(!item.subjectId || !item.subjectCode || !item.subjectName){//增加多个校验
        message('请在资金-账户设置，绑定会计科目！')
        flg = false;
      }else{
        //转入账号
        inAcc = {subjectId:item.subjectId,subjectCode:item.subjectCode,subjectName:item.subjectName}
      }
    }else if(item.id === row.outAccountId){
      if(!item.subjectId || !item.subjectCode || !item.subjectName){//增加多个校验
        message('请在资金-账户设置，绑定会计科目！')
        flg = false;
      }else{
        //转出账号
        outAcc = {subjectId:item.subjectId,subjectCode:item.subjectCode,subjectName:item.subjectName}
      }
    }
  })
  if(!flg){
    return
  }
  Promise.all([
    setting.subject.listByCode(inAcc.subjectCode),
    setting.subject.listByCode(outAcc.subjectCode)
  ]).then((results) => {
    const [inRes, outRes] = results;
    let detailIn = {
      subject:inRes.data[inAcc.subjectCode],
      balanceDirection:inRes.data[inAcc.subjectCode].balanceDirection,
      debitAmount:row.amount,
      creditAmount:0,
      isCarry:true,
      originalCreditAmount:0,
      originalDebitAmount:row.amount,
      subjectId:inRes.data[inAcc.subjectCode].id,
      subjectName:inRes.data[inAcc.subjectCode].name,
      subjectType:inRes.data[inAcc.subjectCode].type,
      summary:'资金内部转账'
    }
    let detailOut = {
      subject:outRes.data[outAcc.subjectCode],
      balanceDirection:outRes.data[outAcc.subjectCode].balanceDirection,
      debitAmount:0,
      creditAmount:row.amount,
      isCarry:true,
      originalCreditAmount:row.amount,
      originalDebitAmount:0,
      subjectId:outRes.data[outAcc.subjectCode].id,
      subjectName:outRes.data[outAcc.subjectCode].name,
      subjectType:outRes.data[outAcc.subjectCode].type,
      summary:'资金内部转账'
    }
    details.push(detailIn)
    details.push(detailOut)
    let layerId = layer.drawer({
      title: "资金内部转账",
      shadeClose: false,
      zIndex: 999,
      area: ['1100px', '100vh'],
      content: h(VoucherForm, {
        internalTransfer:true,
        transferData: details,
        onSuccess: (voucherId) => {
          row.voucherId = voucherId;
          CashierTransfer.save(row).then(() => {
            console.log(row)
            loadList();
          })
          layer.close(layerId);
        },
        onClose: () => {
          layer.close(layerId);
        }
      })
    })
  })
}

const loadList = () => {
  loading.value = true;
  CashierTransfer.list(Object.assign(page.value, query.value, dateRange.value)).then(({data}) => {
    results.value = data;
  }).finally(() => loading.value = false)
}
loadList();

const onPageChange = ({currentPage, pageSize}) => {
  page.value.page = currentPage;
  page.value.pageSize = pageSize;
  loadList();
}

const doSearch = () => {
  page.value.page = 1;
  loadList();
}

const showForm = (entity = null) => {
  let layerId = layer.open({
    title: "转账信息",
    shadeClose: false,
    closeBtn: false,
    zIndex: 1000,
    area: ['500px', 'auto'],
    content: h(InternalTransferForm, {
      entity, accountList: accountList.value,
      onClose: () => {
        layer.close(layerId);
      },
      onReload: () => {
        loadList();
      },
      onSuccess: () => {
        loadList();
        layer.close(layerId);
      }
    })
  });
}


const loadAccount = () => {
  CashierAccount.list().then(({data}) => {
      accountList.value = data;
    })
}
loadAccount();

const printList = () => {
  const $xTable = xTable.value;
	let headerHtml = `<h3>内部转账</h3>
			<div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
				<span> </span>
				<span>${startDate.value} 至 ${endDate.value}</span>
				<span> 单位：元 </span>
			</div>
			`;
	let footerHtml = `<div style="display:flex;justify-content: left;;height:22px;line-height:22px">编制单位：${store.state.currentAccountSets.companyName}</div>`;
	if ($xTable) {
    $xTable.print({	 	
      // 打印样式设置
      style: tablePrint,
      // 打印指定列
      columns: [
        { field: 'transferDate' },
        { field: 'digest' },
        { field: 'billDate' },
        { field: 'outAccount' },
        { field: 'inAccount' },
        // { field: 'deptName' },
        // { field: 'projectName' },
        { field: 'amount' },
        { field: 'remark' },
      ],
      // 打印之前拼接自定义模板
      beforePrintMethod: ({ content }) => {
        // 打印之前，返回自定义的 html 内容
        return headerHtml + content + footerHtml
      }
    })
  }
}

const remove = (row) => {
  confirm({
    content: "确定删除此记录?",
    async: true,
    onConfirm(resolve) {
      CashierTransfer.delete(row.id).then(() => {
        resolve(true)
        loadList();
      }).catch(() => {
        resolve(false)
      })
    }
  })
}

const batchDelete = (row) => {
  let records = xTable.value.getCheckboxRecords().map(row => row.id);
  if (records.length) {
    confirm({
      content: "确定删除此记录?",
      async: true,
      onConfirm(resolve) {
        CashierTransfer.batchDelete(records).then(() => {
          resolve(true)
          loadList();
        }).catch(() => {
          resolve(false)
        })
      }
    })
  } else {
    message.warn("请先选择记录~");
  }
}
</script>
